import { render, staticRenderFns } from "./BenefitNode.vue?vue&type=template&id=655e916c&scoped=true"
import script from "./BenefitNode.vue?vue&type=script&lang=js"
export * from "./BenefitNode.vue?vue&type=script&lang=js"
import style0 from "./BenefitNode.vue?vue&type=style&index=0&id=655e916c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e916c",
  null
  
)

export default component.exports